var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-card"},[_c('div',{staticClass:"title-icon"},[_vm._t("icon"),_c('h3',{staticClass:"card-title"},[_vm._t("title")],2)],2),(_vm.checkIcon)?_c('div',{staticClass:"check-icon"},[(_vm.displayGreenCheck)?_c('section',[_c('Check')],1):_c('section',[_c('Cross')],1)]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }